<template>
  <div
    :class="progressType"
    class="rt-progress"
  >
    <div
      v-if="type == 'line' && top && !textInside"
      class="progress-text"
    >
      <span
        v-if="!status"
        :style="{ fontSize: textSize + 'px', color: textColor == 'theme' ? colorInfo : '' }"
        :class="['is-' + textColor]"
      >{{ content }}</span><rt-icon
        v-else
        :name="status == 'success' ? 'rt-base-circle-check-filled' : 'rt-base-circle-close-filled'"
        :color="status == 'success' ? SCSS_VARIABLES.COLOR_SUCCESS : SCSS_VARIABLES.COLOR_DANGER"
        :size="iconSize"
      />
    </div>
    <div class="progress">
      <el-progress
        ref="progress"
        v-bind="$attrs"
        :class="['is-' + outer, 'is-' + strokeLinecap]"
        :format="textInside ? format : formatEmpty"
        :text-inside="textInside"
        :percentage="percentage"
        :color="colorInfo"
        :type="type"
        :stroke-linecap="strokeLinecap"
        v-on="$listeners"
      ></el-progress>
      <div
        v-if="type == 'circle' || type == 'dashboard'"
        class="circle-progress"
      >
        <div class="progress-text">
          <span
            v-if="!status"
            :style="{ fontSize: textSize + 'px', color: textColor == 'theme' ? colorInfo : '' }"
            :class="['is-' + textColor]"
          >{{ content }}</span><rt-icon
            v-else
            :name="status == 'success' ? 'rt-base-check-lined' : 'rt-base-close-x-lined'"
            :color="status == 'success' ? SCSS_VARIABLES.COLOR_SUCCESS : SCSS_VARIABLES.COLOR_DANGER"
            :size="iconSize"
          />
        </div>
      </div>
    </div>
    <div
      v-if="type == 'line' && !top && !textInside"
      class="progress-text"
    >
      <span
        v-if="!status"
        :style="{ fontSize: textSize + 'px', color: textColor == 'theme' ? colorInfo : '' }"
        :class="['is-' + textColor]"
      >{{ content }}</span><rt-icon
        v-else
        :name="status == 'success' ? 'rt-base-circle-check-filled' : 'rt-base-circle-close-filled'"
        :color="status == 'success' ? SCSS_VARIABLES.COLOR_SUCCESS : SCSS_VARIABLES.COLOR_DANGER"
        :size="iconSize"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtProgress',
  props: {
    format: Function,
    textInside: {
      type: Boolean,
      default: false
    },
    status: {
      type: String
    },
    strokeLinecap: {
      type: String,
      default: 'round'
    },
    iconSize: {
      type: String,
      default: '16'
    },
    textSize: {
      type: String,
      default: '12'
    },
    textColor: {
      type: String,
      default: 'primary'
    },
    outer: {
      type: String,
      default: 'light'
    },
    percentage: {
      type: Number,
      default: 0,
      required: true,
      validator: val => val >= 0 && val <= 100
    },
    type: {
      type: String,
      default: 'line'
    },
    color: {
      type: [String, Function, Array],
      default: 'primary'
    },
    top: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    content () {
      if (typeof this.format === 'function') {
        return this.format(this.percentage) || '';
      } else {
        return `${this.percentage}%`;
      }
    },
    progressType () {
      if (this.type === 'line' && (this.left || this.right) && !this.bottom && !this.top) {
        if (this.left) {
          return 'is-left';
        } else {
          return 'is-flex';
        }
      } else if (this.type === 'circle' || this.type === 'dashboard') {
        return 'is-circle';
      } else {
        return 'is-wrap';
      }
    },
    colorInfo () {
      if (this.color === 'primary') {
        return this.SCSS_VARIABLES.COLOR_PRIMARY;
      }
      if (this.color === 'normal') {
        return this.SCSS_VARIABLES.COLOR_NORMAL;
      }
      if (this.color === 'success') {
        return this.SCSS_VARIABLES.COLOR_SUCCESS;
      }
      if (this.color === 'warning') {
        return this.SCSS_VARIABLES.COLOR_WARNING;
      }
      if (this.color === 'danger') {
        return this.SCSS_VARIABLES.COLOR_DANGER;
      }
      if (this.color === 'info') {
        return this.SCSS_VARIABLES.COLOR_INFO;
      }
      return this.color;
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.type === 'line') {
        if (this.$el.querySelector('.el-progress-bar__inner')) {
          this.$el.querySelector('.el-progress-bar__inner').style.backgroundImage = this.colorInfo;
        }
      }
    });
  },
  methods: {
    formatEmpty () {
      return '';
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtProgress.vue?2eeb2177